import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  Checkbox,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";

export default function useTableChecked(records, headCells, filterFn) {
  const pages = [5, 10, 25, records.length];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblContainer = (props) => (
    <TableContainer
      style={{
        maxHeight: 300,
        minHeight: 300,
      }}
    >
      <Table
        className="table table-striped table-hover table-sm border-table"
        aria-labelledby="tableTitle"
        size="small"
        aria-label="enhanced table"
        style={{ maxHeight: "200px" }}
      >
        {props.children}
      </Table>
    </TableContainer>
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function EnhancedTableHead(props) {
    const { onSelectAllClick, numSelected } = props;
    const createSortHandler = (property) => (event) => {
      handleRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell
            padding="checkbox"
            style={{
              color: "white",
              background: "rgba(5, 81, 130, 1)",
              width: "20px",
            }}
          >
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < records.length}
              checked={records.length > 0 && numSelected === records.length}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "select all desserts" }}
            />
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell
              className="azulGradiant "
              style={{
                color: "#fff",
                width: headCell.width,
                textAlign: headCell.textAlign,
                fontWeight: "bold",
                background: "rgba(5, 81, 130, 1)",
                fontSize: "12px",
              }}
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <TablePagination
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={records.length}
      labelRowsPerPage="Filas Por Pagina"
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const recordsAfterPagingAndSorting = () => {
    return stableSort(
      filterFn.fn(records),
      getComparator(order, orderBy)
    ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  return {
    TblContainer,
    EnhancedTableHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  };
}



// WEBPACK FOOTER //
// ./src/components/useTableChecked.js